import Vue from 'vue'
import Vuex from 'vuex'
import leftmenu from './modules/leftmenu'
import maintoolbar from './modules/maintoolbar'
import mainpage from './modules/mainpage'
import user from './modules/user'
import urls from './modules/urls'
import permission from './modules/admin/permission'
import events from './modules/admin/events'
import date from './modules/admin/date'
import intervals from "@/store/modules/admin/intervals";
import event_admin from "@/store/modules/event/events";
import records from "@/store/modules/event/records";
import publicUser from "@/store/modules/public/public";
import emails from "@/store/modules/admin/emails";

Vue.use(Vuex);

const anonimusUsername = 'AnonimusUser';

export default new Vuex.Store({
    modules: {
        leftmenu,
        maintoolbar,
        mainpage,
        user,
        urls,
        permission,
        events,
        date,
        intervals,
        event_admin,
        records,
        publicUser,
        emails
    },
    state: {},
    getters: {},
    mutations: {},
})
